export enum SearchViewPreference {
  CLASSIC = 'CLASSIC',
  GRID = 'GRID',
}
